import createPage from "../../templates";
import DefaultFilterGridActions from '../../actions/filter-grid'

const createCasiFilter = ({ filterPath }) => createPage({
    formName: 'casi',
    tabs: [
        {
            main: true,
            id: 'filter',
            template: 'filter-grid',
            functionName: 'casi',
            gridFunctionName: 'casi',
            filterEndpoint: '/casi/filter',
            deleteEndpoint: '/casi/{{idnrr}}'
        }
    ],
    actions: DefaultFilterGridActions({
        createPath: filterPath + '/0', //'/casi/0',
        createInitialData: {
            idnrr: 0,
            noteObbligatorie: 'Y',
            consuntivoGiorni: 0.0,
            consuntivoOre: 0.0,
            saldoGiorni: 0.0,
            saldoOre: 0.0
        },
        deleteEndpoint: '/casi/{{idnrr}}',
        exportEndpoint: '/casi/export'
    })
})

export default createCasiFilter